import { Component, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
// import { MatomoTracker } from 'ngx-matomo';
import { AnalyticService } from '@application/analytic/analytic.service';
import { sharedResolution } from '../../../src/shared_resolution';
import { ExternalDataModel, ExternalDataService } from '../Services/api/v2/Units/external-data.service';
import { WebContentButtonsService } from '../Services/api/v2/Units/webContentButtons.service';

enum IframeEvents {
	exit = 'exitIframe',
	submitData = 'externalData',
	externalTracking = 'externalTracking',
	externalPreCaseInfo = 'externalPreCaseInfo',
}

@Component({
	standalone: false,
	selector: 'visiba-embedded-web',
	styles: [
		`
			.iFrame {
				position: fixed;
				left: 0;
				right: 0;
				bottom: 0;
				top: 0px;
				border-width: 0;
				z-index: 2147483647;
				background: #ffffff;
			}
		`,
	],
	template: /*language=html*/ `
		<ng-container *ngIf="ewUrl">
			<iframe [src]="ewUrl" width="100%" allow="encrypted-media *;" height="100%" class="iFrame"></iframe>
		</ng-container>
	`,
})
export class EmbeddedWebComponent implements OnInit, OnDestroy {
	public ewUrl: SafeResourceUrl = null;
	private readonly analyticService = sharedResolution.resolve(AnalyticService);

	constructor(
		public domSanitizer: DomSanitizer,
		private webContentButtonsSerivce: WebContentButtonsService,
		private externalDataService: ExternalDataService,
		private router: Router,
		// private matomoTracker: MatomoTracker,
	) {}

	ngOnInit() {
		this.analyticService.trackPageView({ customTitle: 'Embedded Web' });
		window.addEventListener('message', this.handlePostEventFromIframe, false);

		if (this.webContentButtonsSerivce.selectedEmbeddedContent) {
			this.ewUrl = this.getUrl(this.webContentButtonsSerivce.selectedEmbeddedContent.ewUrl);

			return;
		}

		const url = this.router.routerState.snapshot.root.queryParams['url'];
		if (url) {
			this.ewUrl = this.getUrl(url);
		}
	}

	ngOnDestroy() {
		window.removeEventListener('message', this.handlePostEventFromIframe, false);
	}

	public getUrl(url: string) {
		try {
			return this.domSanitizer.bypassSecurityTrustResourceUrl(decodeURIComponent(url));
		} catch {
			return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
		}
	}

	public handlePostEventFromIframe = (messageEvent): void => {
		const { event, data } = messageEvent.data;

		if (data === undefined) return;

		if (event === IframeEvents.exit && data) {
			const url = data.replace(this.webContentButtonsSerivce.selectedEmbeddedContent.baseUrl, '');
			this.router.navigateByUrl(url);
		} else if (event === IframeEvents.submitData && data) {
			this.externalDataService.submitExternalData(data as ExternalDataModel[]).subscribe((responses) => {
				responses.forEach((response) => this.externalDataService.setGuid(response.data, new Date()));
			});
		} else if (event === IframeEvents.externalTracking && data) {
			// const parsedData = JSON.parse(data);
			// if (parsedData.event) {
			// 	this.matomoTracker.trackEvent(parsedData.event.category, parsedData.event.action);
			// } else if (parsedData.view) {
			// 	this.matomoTracker.setCustomUrl(`${window.location.origin}/appview/${parsedData.view}`);
			// 	this.matomoTracker.setGenerationTimeMs(0);
			// 	this.matomoTracker.trackPageView();
			// }
		} else if (event === IframeEvents.externalPreCaseInfo) {
			sessionStorage.setItem('externalPreCaseInfo', data);
		}
	};
}
